import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';

export const HasFragmentItems = (parsedFragments: ParsedFragmentEntity[]) => {
    const items = parsedFragments
        .flatMap(fragment => fragment.itemTypes)
        .flatMap(itemType => itemType.items)
        .filter(Boolean);

    return items.length > 0;
};
